const normalizeLanguages = (language?: string | undefined): string => {
  const languages: any = {
    de: 'de',
    'de-de': 'de',
    en: 'en',
    'en-us': 'en',
    'en-uk': 'en',
    'en-gb': 'en',
    'en/': 'en',
    'de/': 'de',
  }

  return languages[(language || '').toLowerCase()] || 'de'
}

export default normalizeLanguages
